import React, { useState } from 'react'
import { Form, Input, Button, message, Modal } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import "./login.css"
import { phonePasswordLogin } from '../../api'
import { setAuthSession } from '../../utils/auth'
import nationalEmblemImg from '../../assets/images/national_emblem.webp'
import { useNavigate, Navigate } from 'react-router-dom'

const Login = () => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [modalApi, contextHolder] = Modal.useModal();

    if (localStorage.getItem('token')) {
        return <Navigate to="/wordcloud" replace />
    }

    const handleSubmit = (val) => {
        console.log("val", val)
        if (!val.password || !val.phone) {
            return message.open({
                type: 'warning',
                content: '请输入账号和密码',
            });
        }

        setLoading(true)
        phonePasswordLogin({ phone: val.phone, password: val.password }).then(response => {
            if (response.data && response.data.err_code === 200 && response.data.data && response.data.data.token) {
                const { token, user, is_admin } = response.data.data;
                setAuthSession({ token, username: user?.name || user?.phone, isAdmin: is_admin, userId: user?.id, phone: user?.phone || val.phone });
                navigate('/wordcloud');
            } else {
                throw new Error(response.data?.err_msg || '账号或密码错误');
            }
        }).catch(err => {
            console.error("登录出错:", err);

            const errorText = err?.response?.data?.err_msg || err?.message || '账号或密码错误，请重新输入';
            // 显示错误提示框
            modalApi.error({
                title: '登录失败',
                content: errorText,
                okText: '确定'
            });
        }).finally(() => {
            setLoading(false);
        });
    }
    return (
        <div className="login-page">
            {contextHolder}
            <div className="login-card">
                <div className="login-header">
                    <h2 className="login-title">欢迎登录</h2>
                    <p className="login-subtitle">论文助手 · 助力每一篇论文发表</p>
                </div>
                <Form
                    className="login-form"
                    onFinish={handleSubmit}
                    layout="vertical"
                >
                    <Form.Item name="phone">
                        <Input
                            size="large"
                            prefix={<UserOutlined className="input-icon" />}
                            placeholder="请输入账号"
                        />
                    </Form.Item>
                    <Form.Item name="password">
                        <Input.Password
                            size="large"
                            prefix={<LockOutlined className="input-icon" />}
                            placeholder="请输入密码"
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            loading={loading}
                            block
                            className="login-btn"
                        >
                            登 录
                        </Button>
                    </Form.Item>
                </Form>
            </div>

            <div className='bom-icp-info'>
                <p>&copy; 2026 西安誉致智能科技有限公司</p>
                <div className='icon-gaba-view'>
                    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">陕ICP备2026002960号-4</a>
                    <span>·</span>
                    <img src={nationalEmblemImg} alt="公安备案"/>
                    <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank" rel="noreferrer">陕公网安备61011202001144号</a>
                </div>
            </div>
        </div>
    )
}

export default Login

